{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "integrations": [
    {
      "id": "camp",
      "name": "CAMP"
    },
    {
      "id": "traxxall",
      "name": "Traxxall"
    },
    {
      "id": "veryon",
      "name": "Veryon"
    },
    {
      "id": "quantum",
      "name": "Quantum"
    },
    {
      "id": "corridor",
      "name": "CORRIDOR"
    },
    {
      "id": "partsbase",
      "name": "PartsBase"
    },
    {
      "id": "sharepoint",
      "name": "SharePoint"
    },
    {
      "id": "accounting---erp",
      "name": "Accounting / ERP"
    },
    {
      "id": "flight-operations-systems",
      "name": "Flight Operations Systems"
    }
  ],
  "systemOfRecordStatement": "aviOS works alongside incumbent systems; customer-designated systems remain authoritative for their domains."
}